import {
    PUBLIC_ROUTES,
    // AUTHENTICATED_ROUTES_NO_NAV,
    PUBLIC_ROUTES_BEFORE_VOL_LOGIN
} from "_constants/PageRoutes";

export const RouteHelper = {
    Flattened_Public_Routes
}

function Flattened_Public_Routes(isVolUser) {
    if (isVolUser) {
        return [].concat(PUBLIC_ROUTES /*, AUTHENTICATED_ROUTES_NO_NAV*/);
    }

    return [].concat(PUBLIC_ROUTES, PUBLIC_ROUTES_BEFORE_VOL_LOGIN);
};